/*
 * @Author: lbh
 * @Date: 2020-12-28 14:02:27
 * @LastEditors: lbh
 * @LastEditTime: 2025-10-31 09:28:30
 * @Description: file content
 */
import axios from "../../util/http";
let origin = axios.host();
let memberWeb = origin + "/member-web/api";
let restaurant = origin + "/ricepon-restaurant/api";
let riceponSystem = origin + "/ricepon-system/api";
let riceponMember = origin + "/ricepon-member/api";
let locaMemberWeb = origin + "/localhost_api/api";
let riceponSupport = origin + "/ricepon-support/api";

// 獲取系統主題色
export const getSysSetting = (params) =>
  axios.post(memberWeb + "/system/getSysSetting", params);

// 獲取系統配置 新  settingSection=API&settingName=App_Theme_Color
export const memberSetting = (params) =>
  axios.get(riceponSystem + "/public/memberSetting/get", params);

// 獲取 區域列表, 沒有參數
export const getCountry = (params) =>
  axios.get(riceponSystem + "/public/country/list", params);

// /**
//  * 發送短信
//  * @param {object} params
//  *  phone: 手機號碼碼
//     type: 短信類型
//     smsType: 短信發送類型
//     countryId: 區域id
//  */
// export const sendSms = params =>
//   axios.post(memberWeb + "/system/sendSms", params);

/**
 * 發送短信 - 新
 * @param { phone,countryId,type = 1:注册;,17H5  手機號碼驗證碼登錄（clinkpos域名） } params
 * @returns
 */
export const sendSms = (params) =>
  axios.post(riceponSystem + "/public/sms/send", params);

/**
 * 手機號碼登錄
 * @param {object} params
 *  phone: 電話號碼
    code: 驗證碼
    brandId: 品牌id
    countryId: 區域id
 */
export const loginMember = (params) =>
  axios.post(memberWeb + "/member/loginMember", params);

/**
 * ? 短信登錄 - 新 - 2021-5-7
 * @param {*} params {
 *  phone
 *  code 驗證碼
 *  countryId 區域碼
 * }
 * @returns
 */
export const smsLogin = (params) =>
  axios.post(riceponMember + "/public/sms/login", params);

// ? 密碼登錄
export const passLogin = (params) =>
  axios.post(riceponMember + "/public/login", params);

/**
 * Google 登录
 * @param {{
 *  idToken: string,
 *  brandId?: string
 * }} params
 * @returns
 */
export const googleLogin = (params) =>
  axios.body(riceponMember + "/public/google/login", params);

/**
 * Google + 手机号验证码绑定
 * @param {{
 *  bindTicket: string,
 *  phone: string,
 *  countryId: number,
 *  smsCode: string,
 *  brandId?: string
 * }} params
 * @returns
 */
export const googleBindPhone = (params) =>
  axios.body(riceponMember + "/public/google/bind/phone", params);

/**
 * Google + 旧密码绑定
 * @param {{
 *  bindTicket: string,
 *  phone: string,
 *  countryId: number,
 *  password: string,
 *  brandId?: string
 * }} params
 * @returns
 */
export const googleBindPassword = (params) =>
  axios.body(riceponMember + "/public/google/bind/password", params);

/**
 * 短信註冊 - 新 - 2021-5-7
 * @param {*} params {
 *  phone
 *  countryId 區域id
 *  sex 默認傳0
 *  code 驗證碼
 * }
 * @returns
 */
export const smsRegister = (params) =>
  axios.post(riceponMember + "/public/register", params);

// ?  找回密碼
export const forgetPassword = (params) =>
  axios.post(riceponMember + "/system/forgetPassword", params);

/**
 * ?修改密碼
 * @param {*} params
 * @returns
 */
export const setPassword = (params) =>
  axios.post(riceponMember + "/public/set/password", params);

// 獲取協議
export const getResourceInfo = (params) =>
  axios.post(memberWeb + "/system/getResourceInfo", params);

// 獲取 餐廳 或者 品牌 title keyword description
export const getSeo = (params) =>
  axios.get(restaurant + "/brand/getSeo", params);

// 分頁查詢 品牌 餐廳列表
export const getBrandRestaurantList = (params) =>
  axios.get(restaurant + "/public/brand/getBrandRestaurantList", params);

// 活動 登錄
export const adLogin = (params) =>
  axios.post(riceponMember + "/public/sms/login", params);

// 活動 註冊
export const adRegister = (params) =>
  axios.post(riceponMember + "/public/register", params);

// 加入品牌接口
export const joinBrand = (params) =>
  axios.post(memberWeb + "/member/joinBrand", params);

/**
 * 獲取品牌背景圖信息
 * @param {*} params
 * @returns
 */
export const getBrandByAlias = (params) =>
  axios.get(restaurant + "/brand/getBrandByAlias", params);

/**
 * 獲取品牌配置信息
 * @param {brandId} params
 * @returns
 */
export const getBrandConfigInfo = (params) =>
  axios.post(`${restaurant}/brand/getBrandConfigInfo`, params);

/**
 * app\h5 獲取餐廳拓展數據
 * @param {restaurantId,settingName='restaurantCheckCodeSwitch'} params
 * @returns
 */
export const getBySystemName = (params) =>
  axios.get(`${riceponSystem}/restaurantExt/getByName`, params);

// app 广告页
export const getAd = (params) =>
  axios.get(riceponMember + "/newsInfo/getLatestNewsDetails", params);

/**
 * 記錄日誌
 * @param {"createTime":0,"id":0,"keywords":"關鍵字","operationSteps":"操作","optTime":記錄時間-時間戳,"param":"攜帶數據"} params
 * @returns
 */
export const addLog = (params) =>
  axios.body(riceponMember + "/userOptLog/insert", params);

/**
 * 添加系統日誌
 * @param {
 *  errorType 異常類型：1  APP異常， 2 RicePOS漏單，3 支付失敗，4 H5運行異常
 *  platformType 錯誤來源  0：飯糰APP，1：RicePOS，2：H5，3 別府，4：小程序，5：公眾號
 *  deviceModel 設備型號
 *  systemVersion 設備系統版本
 *  deviceType 設備類型：0 未知，1 Android，2 ios
 *  appVersion APP版本
 *  errorContent 報錯內容
 *  errorUserDetails 報錯用戶信息
 * } params
 * @returns
 */
export const addSystemLogo = (params) =>
  axios.body(`${riceponSystem}/public/systemAlarmErrorLogs/add`, params);

/**
 *根據會員ID獲取賬戶積分總數量
 * @param { memberId } params
 * @returns
 */
export const getMemberAccountTotalPoints = (params) =>
  axios.get(
    `${riceponMember}/accountLogOut/getMemberAccountTotalPoints`,
    params
  );
/**
 * 根據會員ID獲取賬戶總優惠券數量
 * @param { memberId } params
 * @returns
 */
export const getMemberAccountCoupons = (params) =>
  axios.get(`${riceponMember}/accountLogOut/getMemberAccountCoupons`, params);

/**
 * 根據會員ID獲得其賬戶下所有未完結、未支付的訂單
 * @param {*} params
 * @returns
 */
export const getMemberAccountOrders = (params) =>
  axios.get(`${riceponMember}/accountLogOut/getMemberAccountOrders`, params);

/**
 * 保存飯糰賬戶註銷記錄
 * @param {
 *  userId 會員ID
 *  cellphoneNumber 手機號碼
 *  integralRemainingNumber 積分剩餘總量
 *  integralIsOut 是否放棄所有積分、優惠券、訂單記錄，1未勾選、2已勾選
 *  couponRemainingNumber 優惠券剩餘總量
 *  applyReason 申請原因
 * } params
 * @returns
 */
export const saveAccountLogOutTo = (params) =>
  axios.body(`${riceponMember}/accountLogOut/saveAccountLogOutTo`, params);

/**
 * 校驗短信
 * @param {
 *  phone 电话
 *  code 验证码
 *  countryId 区域码
 * } params
 * @returns
 */
export const checkSms = (params) =>
  axios.get(`${riceponSystem}/public/sms/checkSmsCode`, params);

/**
 * 根據id 查詢系統級別的 廣告
 * @param {
 *  eventTypeId 1 app啟動頁  /  2 掃碼點餐餐牌頁 / 3 固定碼餐牌頁
 * } params
 * @returns
 */
export const getByEventTypeId_ = (params) =>
  axios.get(`${riceponSystem}/advertiseEvent/getByEventTypeId`, params);

/**
 * 獲取廣告信息
 * http://gingersoft.tpddns.cn:53000/project/75/interface/api/10164
 * @param {
 *  id
 * } params
 * @returns
 */
export const getByEventTypeId = (params) =>
  axios.get(`${riceponSystem}/advertiseEvent/getById`, params);

// 獲取叫號輪播
export const getSwiper = (params) =>
  axios.get(riceponSystem + "/public/carousel/get", params);

/**
 * 埋點數據
 * @param {
 *  appType 來源
 *  webSource  來源session
 *  memberId 會員id
 *  deviceId 设备id
 *  environment 客户端自定义环境信息
 *  brandId 品牌id
 *  restaurantId 餐廳id
 *  logType 埋點類型
 * } params
 * @returns
 */
export const addClickHead = (params) =>
  axios.body(`${riceponSupport}/public/addClickHead`, params);

/**
 * 查詢 環境配置 oss  或者  aws
 * @param {*} params
 * @returns
 */
export const getImageConfig = (params) =>
  axios.get(`${riceponSystem}/admin/imageConfig/getImageConfig`, params);

/**
 * 批量查詢 餐廳拓展配置
 * @param {
 *  restaurantId：餐廳ID
 *  settingNames：配置名稱（多個用逗號隔開即可）
 * } params
 * @returns
 */
export const getBySettingNameList = (params) => {
  return new Promise((a, b) => {
    axios
      .get(`${riceponSystem}/restaurantExt/getBySettingNameList`, params)
      .then((res) => {
        if (res.success) {
          let data = res.data || [];
          let json = {};
          for (let i in data) {
            json[data[i].settingName] = data[i];
          }
          a({
            success: true,
            data: json,
          });
        } else a(res);
      })
      .catch((err) => {
        b(err);
      });
  });
};

/**
 * * 獲取廣告
 * @param {
 *  brandId: 1
 *  type: 100
 * } params
 * @returns
 */
export const getAdvert = (params) =>
  axios.get(`${riceponSystem}/public/advert/get`, params);
